import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/burger-icon-v2.svg'
import _imports_1 from '@/assets/icons/logo-black-v2.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "section-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["burger", { 'burger-active': $props.modelValue }]),
      onClick: $setup.toggleBurger
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("img", { src: _imports_0 }, null, -1)
    ]))], 2),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/v2" }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "LotTrackr"
          }, null, -1)
        ]))]),
        _: 1
      })
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_3, _toDisplayString($setup.currentRoute), 1)
  ]))
}